//Layouts
import LayoutAdmin from "../layouts/LayoutAdmin";

//Pages
import SingIn from "../pages/SignIn";
import Error404 from "../pages/Error404";
import Home from "../pages/Home";

//Pages Admin
import Users from "../pages/Admin/Users";
import Suppliers from "../pages/Admin/Suppliers";
import SupplierDetail from "../pages/Admin/SupplierDetail";
import UploadCertificates from "../pages/Admin/UploadCertificates";
import SuppliersUser from "../pages/Supplier/SuppliersUser";
import UploadUsers from "../pages/Admin/UploadUsers";
import ReportLogCertificate from "../pages/Report/Logcertificate";

const routes = [
  {
    path: "/proveedor",
    exact: false,
    component: LayoutAdmin,
    routes: [
      {
        path: "/proveedor/certificados",
        component: SuppliersUser,
        exact: true,
      },
      {
        path: "/proveedor/certificados/:id",
        component: SupplierDetail,
        exact: true,
      },
      {
        component: Error404,
      },
    ],
  },
  {
    path: "/admin",
    exact: false,
    component: LayoutAdmin,
    routes: [
      {
        path: "/admin/proveedores",
        component: Suppliers,
        exact: true,
      },
      {
        path: "/admin/proveedores/:id",
        component: SupplierDetail,
        exact: true,
      },
      {
        path: "/admin/usuarios",
        component: Users,
        exact: true,
      },
      {
        path: "/admin/cargausuarios",
        component: UploadUsers,
        exact: true,
      },
      {
        path: "/admin/cargacertificados",
        component: UploadCertificates,
        exact: true,
      },
      {
        component: Error404,
      },
    ],
  },
  {
    path: "/inicio",
    exact: false,
    component: LayoutAdmin,
    routes: [
      {
        path: "/inicio",
        exact: true,
        component: Home,
      },
      {
        component: Error404,
      },
    ],
  },
  {
    path: "/recover",
    exact: false,
    component: LayoutAdmin,
    routes: [
      {
        path: "/recover/:cod",
        exact: true,
        component: Home,
      },
      {
        component: Error404,
      },
    ],
  },
  {
    path: "/reportes",
    exact: false,
    component: LayoutAdmin,
    routes: [
      {
        path: "/reportes/consultacertificados",
        component: ReportLogCertificate,
        exact: true,
      },
      {
        component: Error404,
      },
    ],
  },
  {
    path: "/",
    exact: false,
    component: LayoutAdmin,
    routes: [
      {
        path: "/",
        exact: true,
        component: SingIn,
      },
      {
        component: Error404,
      },
    ],
  },
];

export default routes;
